// this is referenced from webpack config, make sure it is matching regex in it when changing.
export const badgingVersion = '1.0.0-alpha.130';
